var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{class:_vm.classess,attrs:{"label":_vm.label,"label-for":_vm.id}},[_c('v-select',{staticClass:"w-100",attrs:{"id":_vm.id,"options":['100%', '70%', '50%', '30%'],"value":_vm.value,"clearable":false,"searchable":false},on:{"input":function (val) {
      _vm.$emit('update:value', val)
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }